import { FC, PropsWithChildren } from 'react';
import { SlideContainer } from './atoms/slide-container';
import { SlidePanel } from './atoms/slide-panel';
import { SlideCarouselProvider } from './provider';
import { SlideNavigation } from './slide-navigation';

interface SlideCarouselProps {
  slides: string[];
  initialSlide?: string;
  canDrag?: boolean;
  slideGap?: number;
}

interface SlideCarouselNamespace extends FC<PropsWithChildren<SlideCarouselProps>> {
  Container: typeof SlideContainer;
  Panel: typeof SlidePanel;
  Navigation: typeof SlideNavigation;
}

export const SlideCarousel: SlideCarouselNamespace = ({
  children,
  slides,
  initialSlide,
  canDrag = true,
  slideGap = 0,
}) => {
  return (
    <SlideCarouselProvider slides={slides} initialSlide={initialSlide} canDrag={canDrag} slideGap={slideGap}>
      {children}
    </SlideCarouselProvider>
  );
};

SlideCarousel.Container = SlideContainer;
SlideCarousel.Panel = SlidePanel;
SlideCarousel.Navigation = SlideNavigation;

export { useSlideCarousel } from './provider';
